import React from "react";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { appContext } from "../../../../AppContext";
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import IbssCheckBox from "../../../../Components/Inputs/CheckBox/IbssCheckBox";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";

class EventInfo extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps) 
    {
        super(props);
        this.state =
        {
            eventName: '',
            hostName: '',
            location: '',
            phone: '',
            eventStartTime: '',
            eventEndTime: '',
            capacity: '',
            ticketPrice: '',
            allowWaitingList: false,
            internalExternal: '',
        };
    }

    public render(): JSX.Element
    {
        const {
            eventOwner,
            eventOwnerChange,
            eventTitle,
            eventTitleChange,
            shortDescription,
            eventShortDescriptionChange,
            webUrl,
            eventWebUrlChange,
            phoneNumber,
            phoneNumberChange,
            fullDescription,
            fullDescriptionChange,
            cateringAvailable,
            crossBuildingFilterChange,
        } = this.props;

        return (
            <>
                <Grid item xs={12}>
                    <Typography variant="h6" marginBottom={2}>
                        {this.labels.funcEventInfo_S}
                    </Typography>
                    <IbssTextField
                        disabled
                        fullWidth
                        label={this.labels.funcEventOwner_S}
                        name="eventOwner"
                        value={eventOwner}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> eventOwnerChange(event.target.value)}
                        
                    />
                </Grid>
                <Grid item xs={12}>
                    <IbssTextField
                        fullWidth
                        label={this.labels.funcEventTitle_S}
                        name="eventTitle"
                        value={eventTitle}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> eventTitleChange(event.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <IbssTextField
                        fullWidth
                        label={this.labels.funcShortDescription_L}
                        name="shortDescription"
                        value={shortDescription}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> eventShortDescriptionChange(event.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <IbssTextField
                        fullWidth
                        label={this.labels.funcFullDescription_S}
                        name="fullDescription"
                        value={fullDescription}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> fullDescriptionChange(event.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <IbssTextField
                        fullWidth
                        label={this.labels.funcWebURL_S}
                        name="weburl"
                        value={webUrl}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> eventWebUrlChange(event.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <IbssTextField
                        fullWidth
                        label={this.labels.funcPhoneNumber_S}
                        name="phone"
                        type="number"
                        value={phoneNumber}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> phoneNumberChange(event.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={6}>
                    <IbssCheckBox
                        label={this.labels.funcCateringAtEvent_L}
                        checked={cateringAvailable}
                        onClicked={(event: React.ChangeEvent<HTMLInputElement>) => crossBuildingFilterChange(event.target.checked)}
                        />
                </Grid>
            </>
        );
    }
}

export default EventInfo;

interface IProps
{
    eventOwner: string;
    eventOwnerChange: (value: string) => void;
    eventTitle: string;
    eventTitleChange: (value: string) => void;
    shortDescription: string;
    eventShortDescriptionChange: (value: string) => void;
    webUrl: string;
    eventWebUrlChange: (value: string) => void;
    phoneNumber: string;
    phoneNumberChange: (value: string) => void;
    fullDescription: string;
    fullDescriptionChange: (value: string) => void;
    cateringAvailable: boolean;
    crossBuildingFilterChange: (checked: boolean) => void;
}

interface IState
{
    eventName: string;
    hostName: string;
    location: string;
    phone: string;
    eventStartTime: string;
    eventEndTime: string;
    capacity: string;
    ticketPrice: string;
    allowWaitingList: boolean;
    internalExternal: string;
}

export interface ICallToAction
{
    id: string;
    title: string;
    description: string;
    buttonLabel: string;
    src: string;
    imageAlt: string;
    route: string;
    permissions: boolean;
}

